import { useState } from "react";

import { icon_paypal_wallet } from "../images/icons";

interface PaymentOption {
  id: string;
  headline: string;
  description: string;
  imageSrc: string;
}

/**
 * Custom React hook that manages available payment options and the currently selected payment option.
 *
 * @returns An object containing:
 * - `paymentOptions`: Array of available payment options.
 * - `selectedPayment`: The currently selected payment option object.
 * - `selectedPaymentId`: The ID of the currently selected payment option.
 * - `setSelectedPaymentId`: Function to update the selected payment option by ID.
 */
export const usePaymentOptions = () => {
  const [selectedPaymentId, setSelectedPaymentId] = useState<string>("paypal");

  const paymentOptions: PaymentOption[] = [
    {
      id: "paypal",
      headline: "PayPal",
      description: "Du wirst zu PayPal weitergeleitet, wo du deine Bestellung bezahlen und abschließen kannst.",
      imageSrc: icon_paypal_wallet,
    },
    // Weitere Optionen bei Bedarf ergänzen
  ];

  const selectedPayment = paymentOptions.find(opt => opt.id === selectedPaymentId);

  return {
    paymentOptions,
    selectedPayment,
    selectedPaymentId,
    setSelectedPaymentId,
  };
};
